const isPro = process.env.NODE_ENV === "production";
const host = process.env.DEV_HOST;

export const subAppsConfig = [
  // vue2 subApp
  {
    name: "sub-app-vue2",
    entry: isPro ? '/subams/coop-management' : `//${host}:6092/`,
    activeRule: '/ams/coop-management', // 可以是数组
    container: "#app-main-content"
  },
  // vue3 subApp
  {
    name: "sub-app-vue3",
    entry: isPro ? '/subams/sub-app-vue3' : `//${host}:6093`,
    activeRule: "/ams/sub-app-vue3",
    container: "#app-main-content"
  },
];
